import { styled } from "goober";
import type { TenantRole } from "../hooks/useTenantRoles";
import { Text } from "./Text";
import { Toggle } from "./Toggle";

const ToggleGroup = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 8px;
`;

const ToggleRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export function TenantRolesChecklist({
  roles,
  assignedBuiltinRoleIds,
  assignedCustomRoleIds,
  onToggle,
  disabled,
}: {
  roles: TenantRole[];
  assignedBuiltinRoleIds: Set<string>;
  assignedCustomRoleIds: Set<string>;
  onToggle: (role: TenantRole) => void;
  disabled?: boolean;
}) {
  if (roles.length === 0) return null;

  return (
    <ToggleGroup>
      {roles.map((role) => {
        const checked =
          role.kind === "builtin"
            ? assignedBuiltinRoleIds.has(role.id)
            : assignedCustomRoleIds.has(role.id);
        return (
          <ToggleRow key={role.id}>
            <Text variant="text-regular" ellipsis>
              {role.label}
            </Text>
            <Toggle
              isOn={checked}
              onToggle={() => onToggle(role)}
              disabled={disabled}
            />
          </ToggleRow>
        );
      })}
    </ToggleGroup>
  );
}
